if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        const prevBtn = this.querySelector('.product-media-modal__prev');
        const nextBtn = this.querySelector('.product-media-modal__next');
        if (prevBtn) {
          prevBtn.addEventListener('pointerup', (e) => e.stopPropagation());
          prevBtn.addEventListener('click', () => this.navigateMedia(-1));
        }
        if (nextBtn) {
          nextBtn.addEventListener('pointerup', (e) => e.stopPropagation());
          nextBtn.addEventListener('click', () => this.navigateMedia(1));
        }
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
      }

      showActiveMedia() {
        this.querySelectorAll(
          `[data-media-id]:not([data-media-id="${this.openedBy.getAttribute('data-media-id')}"])`
        ).forEach((element) => {
          element.classList.remove('active');
        });
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute('data-media-id')}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateNavButtons();
      }

      navigateMedia(direction) {
        const allMedia = Array.from(this.querySelectorAll('[data-media-id]'));
        const activeMedia = this.querySelector('[data-media-id].active');
        const currentIndex = allMedia.indexOf(activeMedia);
        let newIndex = currentIndex + direction;
        if (newIndex < 0) newIndex = allMedia.length - 1;
        if (newIndex >= allMedia.length) newIndex = 0;

        activeMedia.classList.remove('active');
        const newMedia = allMedia[newIndex];
        newMedia.classList.add('active');
        newMedia.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      updateNavButtons() {
        const prevBtn = this.querySelector('.product-media-modal__prev');
        const nextBtn = this.querySelector('.product-media-modal__next');
        if (prevBtn) prevBtn.style.display = 'flex';
        if (nextBtn) nextBtn.style.display = 'flex';
      }
    }
  );
}
